module.exports = __webpack_public_path__ + "static/media/meatballs-light.66df88e6.svg";